import request from "reqwest";
import when from "when";
import UserStore from "../store/user-store.js";
import $ from "jquery";

class BaseService {
  getAPI() {
    if (window.location.href.includes("localhost")) {
      //return "http://localhost.services.languagenut.com/";
      //return 'https://services_gamma.languagenut.com/'
      // return 'https://api.languagenut.cn/'
      //return 'https://asia_api.languagenut.com/'
      return "https://api.languagenut.com/";
    } else if (window.location.href.includes("gamma")) {
      return "https://services_gamma.languagenut.com/";
    } else if (window.location.href.includes("asia")) {
      return "https://asia_api.languagenut.com/";
    } else if (window.location.href.includes("languagenut.cn")) {
      return "https://api.languagenut.cn/";
    } else if (window.location.href.includes("resourcestest")) {
      return "https://apitest.languagenut.com/";
    }

    return "https://api.languagenut.com/";
  }

  addDataConstants(data) {
    data.token = sessionStorage.getItem("USER_TOKEN") || sessionStorage.getItem("token");
    data.accountUID = UserStore.account.account_uid;
    data.languagenutStatistics = window.languagenutStatistics;
    window.languagenutStatistics = [];
    return data;
  }

  handleService(url, data, files) {
    const addDataConstants = this.addDataConstants(data);

    if (files == null) {
      return when(
        request({
          url: url,
          method: "post",
          data: addDataConstants,
          crossOrigin: true,
          type: "json",
        })
      );

      /// lock ---
    }

    return new Promise((resolve) => {
      $.ajax(
        {
          url: `${url}?${$.param(addDataConstants)}`,
          type: "POST",
          timeout: 150000,
          crossDomain: true,
          data: files,
          cache: false,
          contentType: false,
          processData: false,
          dataType: "json",
          success: (data) => resolve(data),
        },
        "json"
      );
    });
  }

  call(url, data, files) {
    return new Promise(async (resolve) => {
      const response = await this.handleService(this.getAPI() + url, data, files);

      if (response.token || response.newToken) {
        sessionStorage.setItem("USER_TOKEN", response.token || response.newToken);
      }

      if (response.Error && response.Error === "U1" && response.msg && response.msg === "invalidToken") {
        if (window.location.href.includes("LoginScreen")) {
          return;
        }
        window.languagenutPreviousHash = window.location.hash;
        window.location.hash = "#/";
      }

      resolve(response);
    });
  }
}

export default new BaseService();
